import styled from 'react-emotion'

const ScrollArea = styled('div')({
  label: 'ScrollArea',
  overflow: 'auto',
  flex: 1
})

export default ScrollArea
